module.exports = __webpack_public_path__ + "static/06-2a94c457247ee767ba9456158c56e778.jpg";